export function getWidgetData(yItem, sysName) {
	const widgetData = yItem.get('widgets_data').get(sysName) || {};
	return {
		amount: widgetData.amount || 0,
		content: widgetData.content || null,
	}
}

export function saveWidgetData(yItem, sysName, newData) {
	const widgetsData = yItem.get('widgets_data');
	const originalData = getWidgetData(yItem, sysName);
	newData = Object.assign(originalData, newData);
	widgetsData.set(sysName, newData);
}
